import { render, staticRenderFns } from "./ProfileBackground.vue?vue&type=template&id=e8e7306a&"
import script from "./ProfileBackground.vue?vue&type=script&lang=js&"
export * from "./ProfileBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports